import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

export type RestartLlmBatchStatus =
    | 'ValidationFailed'
    | 'NotEligible'
    | 'DispatchInFlight'
    | 'Completed'
    | 'Failed'
    | string;

export type RestartLlmBatchResponse = {
    status: RestartLlmBatchStatus;
    message?: string;
    barcode?: string;
    cancelledJobCount?: number;
    revertedFrameCount?: number;
    dispatchQueued?: boolean;
};

const pick = (raw: Record<string, unknown>, camel: string, pascal: string) =>
    raw[camel] ?? raw[pascal];

const pickString = (raw: Record<string, unknown>, key: string) =>
    String(pick(raw, key, key.charAt(0).toUpperCase() + key.slice(1)) ?? '');

const pickNumber = (raw: Record<string, unknown>, key: string) => {
    const value = pick(raw, key, key.charAt(0).toUpperCase() + key.slice(1));
    return value == null ? undefined : Number(value);
};

const pickBool = (raw: Record<string, unknown>, key: string) =>
    Boolean(pick(raw, key, key.charAt(0).toUpperCase() + key.slice(1)));

/** BFF Newtonsoft bazen enum'u sayı gönderir. */
const normalizeStatus = (value: unknown): RestartLlmBatchStatus => {
    if (value == null) {
        return '';
    }
    if (typeof value === 'number') {
        switch (value) {
            case 0:
                return 'ValidationFailed';
            case 1:
                return 'NotEligible';
            case 2:
                return 'DispatchInFlight';
            case 3:
                return 'Completed';
            case 4:
                return 'Failed';
            default:
                return String(value);
        }
    }
    return String(value).trim();
};

const mapResponse = (raw: Record<string, unknown>): RestartLlmBatchResponse => ({
    status: normalizeStatus(pick(raw, 'status', 'Status')),
    message: pickString(raw, 'message') || undefined,
    barcode: pickString(raw, 'barcode') || undefined,
    cancelledJobCount: pickNumber(raw, 'cancelledJobCount'),
    revertedFrameCount: pickNumber(raw, 'revertedFrameCount'),
    dispatchQueued: pickBool(raw, 'dispatchQueued'),
});

const RestartLlmBatch = async (barcode: string): Promise<RestartLlmBatchResponse> => {
    const raw = (await request({
        url: ApiURL.Command.StudioCommandURLs.BatchProcessTrackingCommandURL.RestartLlmBatch,
        method: RequestType.POST,
        data: { barcode },
    })) as Record<string, unknown>;

    return mapResponse(raw);
};

export const BatchProcessTrackingCommand = {
    RestartLlmBatch,
};
